import { FC } from "react";

interface IconProps {
  color?: string;
}

const ClosedEye: FC<IconProps> = ({ color = "#525A6A" }) => (
  <svg viewBox="0 0 16 16" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.507 9.578a2.082 2.082 0 0 1-.617-1.486 2.106 2.106 0 0 1 3.596-1.494M10.07 8.466a2.105 2.105 0 0 1-1.692 1.695"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M4.436 11.648c-1.058-.83-1.954-2.044-2.603-3.556.656-1.52 1.558-2.74 2.623-3.577C5.514 3.678 6.734 3.223 8 3.223c1.272 0 2.492.461 3.557 1.305M12.965 5.994c.459.61.862 1.313 1.201 2.097C12.855 11.13 10.538 12.96 8 12.96a5.32 5.32 0 0 1-1.688-.275M13.258 2.833 2.742 13.35"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default ClosedEye;
